import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
} from '@angular/core';

import { TabComponent } from './tab/tab.component';
import { ITabConfig } from '../../interfaces/tab.interface';

/**
 * TabsComponent is a container component that manages multiple TabComponent instances.
 * It handles the logic for activating and displaying the selected tab.
 */
@Component({
  selector: 'app-tabs',
  imports: [],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent> =
    new QueryList<TabComponent>();

  /**
   * Index of the initially selected tab. Default is 0.
   */
  @Input() public initialTabIndex: number = 0;

  /**
   * Configuration object for customizing the tab styles.
   */
  @Input() public config: ITabConfig | null = null;

  /**
   * Event emitted when the active tab changes.
   */
  @Output() tabChange = new EventEmitter();

  private activeTabIndex: number = 0;

  /**
   * Lifecycle hook that is called after the component's content has been fully initialized.
   */
  ngAfterContentInit(): void {
    if (this.tabs?.length) {
      this.selectTab(this.initialTabIndex || 0, true);
    }
  }

  /**
   * Activates the tab at the specified index.
   * @param index - The index of the tab to activate.
   * @param isInitial - Flag indicating if this is the initial activation. Default is false.
   */
  public selectTab(index: number, isInitial: boolean = false): void {
    this.tabs.forEach((tab, i) => {
      tab.isActive = i === index;
    });

    this.activeTabIndex = index;

    this.tabChange.emit({ tab: this.tabs.toArray()[index], index });
  }
}
